import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import "./boardpage.css";
import {IMAGE_URL, SOCKET} from "../../URL";
import {
    HandleBoardAPI,
    BoardAPI,
    BoardListsAPI,
    CreateBoardCardAPI,
    CreateBoardListAPI,
    RenameBoard,
    RemoveBoardAPI,
    HandleBoardListAPI,
    RemoveBoardListAPI
} from "../../store/api/get/Board/Board";
import {
    ADD_CARD_TO_LIST,
    ARCHIVE_BOARD,
    CREATE_BOARD_LIST, DELETE_ATTACHMENT, MAKE_COVER,
    SET_ACTIVE_BOARD, SET_ATTACHMENT,
    SET_BOARD_LISTS, SET_COMMENT
} from "../../store/constants";
import {BoardPageHeader} from "./components/BoardPageHeader/BoardPageHeader";
import {Lists} from "./components/Contents/Lists/Lists";
import {ListCreate} from "./components/Contents/Lists/ListCreate";
import {ModalArchiveLists} from "./components/Contents/Modals/ArchiveLists/ModalArchiveLists";
import {ModalArchiveBoard} from "./components/Contents/Modals/ArchiveBoard/ModalArchiveBoard";
import {ArchiveLists} from "./components/Contents/Modals/ArchiveLists/ArchiveLists";
import {ArchiveCards} from "./components/Contents/Modals/ArchiveCards/ArchiveCards";
import {ShareModal} from "./components/Contents/Modals/Share/ShareModal";

export const BoardPage = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const activeBoard = useSelector((state) => state.boards.activeBoard || {});
    const isShowShare = useSelector((state) => state.boards?.isShowShare);
    const userRole = activeBoard?.rbac?.find(
        (el) => el.user_id === user?.id
    )?.role;
    const lists = useSelector((state) => state.boards.boardLists || []);

    const [isChangeBoardText, setIsChangeBoardText] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);

    const [actionTargetType, setActionTargetType] = useState(null);
    // "board" | "list" | "archiveLists" | null

    const [boardAction, setBoardAction] = useState(null);
    // "archive" | "delete" | "view" | null
    const [selectedListId, setSelectedListId] = useState(null);

    const menuRef = useRef(null);
    const modalRef = useRef(null);

    const [showCreateList, setShowCreateList] = useState(false);
    const [listTitle, setListTitle] = useState("");

    const [activeListId, setActiveListId] = useState(null);
    const [cardTitle, setCardTitle] = useState("");

    const [openListMenuId, setOpenListMenuId] = useState(null);
    useEffect(() => {

        if (!activeBoard?.id) return;

        SOCKET.emit("join_board", activeBoard.id);

        return () => {
            SOCKET.emit("leave_board", activeBoard.id);
        };

    }, [activeBoard?.id]);
    useEffect(() => {
        if (!activeBoard?.id || String(activeBoard.id) !== String(id)) {
            dispatch(BoardAPI(id));
        }
    }, [dispatch, id, activeBoard?.id]);

    useEffect(() => {
        if (!activeBoard?.id) return;
        const updated_at = new Date().getTime()
        dispatch(BoardListsAPI(activeBoard.id, updated_at));
    }, [dispatch, activeBoard?.id]);

    useEffect(() => {
        if (!activeBoard || !user) return;
        if (!Array.isArray(activeBoard.rbac)) return;

        const isOwner = Number(activeBoard.user_id) === Number(user.id);

        const hasAccess = activeBoard.rbac.some(
            (el) => Number(el.user_id) === Number(user.id)
        );

        if (!isOwner && !hasAccess) {
            navigate("/cabinet");
        }
    }, [activeBoard, user, navigate]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }

            if (!event.target.closest?.(".boardList__menuWrap")) {
                setOpenListMenuId(null);
            }

            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };

        const handleEsc = (event) => {
            if (event.key === "Escape") {
                setIsMenuOpen(false);
                setOpenListMenuId(null);
                setIsChangeBoardText(false);
                closeModal();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEsc);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEsc);
        };
    }, []);

    const closeModal = () => {
        setIsCloseModalOpen(false);
        setBoardAction(null);
        setActionTargetType(null);
        setSelectedListId(null);
    };

    const handleCreateList = async (e) => {
        e.preventDefault();
        let sort;
        if (lists.length === 0) {
            sort = 1;
        } else {
            sort = lists[lists.length - 1].sort + 1;
        }
        if (!listTitle.trim() || !activeBoard?.id) return;
        await dispatch(CreateBoardListAPI(activeBoard.id, listTitle.trim(), sort));

        setListTitle("");
        setShowCreateList(false);
    };

    useEffect(() => {
        const handleBoardList = (data) => {
            dispatch({
                type: CREATE_BOARD_LIST,
                payload: data.list
            });
        };

        SOCKET.on("board_list", handleBoardList);

        return () => {
            SOCKET.off("board_list", handleBoardList);
        };
    }, [dispatch]);
    const handleCreateCard = async (e, listId) => {
        e.preventDefault();

        if (!cardTitle.trim()) return;

        await dispatch(CreateBoardCardAPI(listId, cardTitle.trim(), activeBoard?.id));

        setCardTitle("");
        setActiveListId(null);
    };
    useEffect(() => {
        const handleBoardCard = (data) => {
            dispatch({
                type: ADD_CARD_TO_LIST,
                payload: data
            });
        };

        SOCKET.on("board_card", handleBoardCard);

        return () => {
            SOCKET.off("board_card", handleBoardCard);
        };
    }, [dispatch]);
    const handleChangeBoardName = (e) => {
        if (e.key === "Enter") {
            const newName = e.target.value.trim();
            setIsChangeBoardText(false);

            if (newName && newName !== activeBoard?.name) {
                dispatch(RenameBoard(activeBoard?.id, newName));
            }
        }

        if (e.key === "Escape") {
            setIsChangeBoardText(false);
        }
    };

    useEffect(() => {
        SOCKET.on("board_renamed", (data) => {
            dispatch({
                type: SET_ACTIVE_BOARD,
                payload: data.board
            });
        });

        return () => {
            SOCKET.off("board_renamed");
        };
    }, [dispatch]);
    useEffect(() => {
        SOCKET.on("board_lists", (data) => {
            dispatch({
                type: SET_BOARD_LISTS,
                payload: data.lists
            });
        });

        return () => {
            SOCKET.off("board_lists");
        };
    }, [dispatch]);
    useEffect(() => {
        const handleUploadAttachment = (data) => {
            dispatch({
                type: SET_ATTACHMENT,
                payload: data.attachment
            });
        };

        SOCKET.on("upload_attachment", handleUploadAttachment);

        return () => {
            SOCKET.off("upload_attachment", handleUploadAttachment);
        };
    }, [dispatch]);
    useEffect(() => {
        SOCKET.on("delete_attachment", (data) => {
            dispatch({
                type: DELETE_ATTACHMENT,
                payload: data.attachment_id
            });
        });

        return () => {
            SOCKET.off("delete_attachment")
        }
    }, [dispatch]);
    useEffect(() => {
        SOCKET.on("make_cover", (data) => {
            dispatch({type: MAKE_COVER, payload: data.cover})
        });

        return () => {
            SOCKET.off("make_cover");
        }
    }, [dispatch]);
    const handleOpenActionModal = ({targetType, action, listId = null}) => {
        setActionTargetType(targetType);
        setBoardAction(action);
        setSelectedListId(listId);
        setIsMenuOpen(false);
        setOpenListMenuId(null);
        setIsCloseModalOpen(true);
    };

    const handleArchiveLists = () => {
        setIsMenuOpen(false);
        setActionTargetType("archiveLists");
        setBoardAction("view");
        setSelectedListId(null);
        setIsCloseModalOpen(true);
    };
    const handleArchiveCards = () => {
        setIsMenuOpen(false);
        setActionTargetType("archiveCards");
        setBoardAction("view");
        setSelectedListId(null);
        setIsCloseModalOpen(true);
    };
    const handleRestoreList = async (listId) => {
        if (userRole !== 1) {
            const updatedList = await dispatch(HandleBoardListAPI(listId));
            dispatch({
                type: SET_BOARD_LISTS,
                payload: lists.map((list) =>
                    list.id === updatedList.id
                        ? {...list, is_archive: updatedList.is_archive}
                        : list
                ),
            });
            setIsCloseModalOpen(false);
        }
    };

    const handleConfirmAction = async () => {
        try {
            if (actionTargetType === "board") {
                if (!activeBoard?.id || !boardAction) return;

                if (boardAction === "archive") {
                    if (userRole !== 1) {
                        dispatch({type: ARCHIVE_BOARD, payload: true});
                        await dispatch(HandleBoardAPI(activeBoard.id));
                    }
                }

                if (boardAction === "delete") {
                    if (userRole !== 1) {
                        await dispatch(RemoveBoardAPI(activeBoard.id));
                    }
                }

                closeModal();
                navigate("/cabinet");
                return;
            }

            if (actionTargetType === "list") {
                if (!selectedListId || !boardAction) return;
                if (boardAction === "archive") {
                    if (userRole !== 1) {
                        const updatedList = await dispatch(HandleBoardListAPI(selectedListId));
                        dispatch({
                            type: SET_BOARD_LISTS,
                            payload: lists.map((list) =>
                                list.id === updatedList.id
                                    ? {...list, is_archive: updatedList.is_archive}
                                    : list
                            ),
                        });
                    }
                }

                if (boardAction === "delete") {
                    if (userRole !== 1) {
                        await dispatch(RemoveBoardListAPI(selectedListId));
                    }
                }

                closeModal();
                return;
            }
        } catch (error) {
            console.log("Action error:", error);
        }
    };
    useEffect(() => {
        const handleBoard = (data) => {
            dispatch({
                type: ARCHIVE_BOARD,
                payload: data.is_archive
            });

            navigate("/cabinet");
        };

        SOCKET.on("handle_board", handleBoard);

        return () => {
            SOCKET.off("handle_board", handleBoard);
        };
    }, [dispatch]);
    useEffect(() => {
        const removeBoard = () => {
            navigate("/cabinet");
        }
        SOCKET.on("remove_board", removeBoard);

        return () => {
            SOCKET.off("remove_board", removeBoard)
        }
    }, []);
    useEffect(() => {
        const handleAddComment = (data) => {
            dispatch({
                type: SET_COMMENT,
                payload: data,
            });
        };

        SOCKET.on("add_comment", handleAddComment);

        return () => {
            SOCKET.off("add_comment", handleAddComment);
        };
    }, [dispatch]);
    const getActionConfig = () => {
        if (actionTargetType === "board" && boardAction === "archive") {
            return {
                title: "Archive board?",
                text: (
                    <>
                        You can find and reopen archived boards at the bottom of{" "}
                        <span className="closeBoardModal__link">
                            your boards page
                        </span>.
                    </>
                ),
                buttonText: "Archive",
            };
        }

        if (actionTargetType === "board" && boardAction === "delete") {
            return {
                title: "Delete board?",
                text: <>This board will be permanently removed. This action cannot be undone.</>,
                buttonText: "Delete",
            };
        }

        if (actionTargetType === "list" && boardAction === "archive") {
            return {
                title: "Archive list?",
                text: <>This list will be archived. You can restore it later.</>,
                buttonText: "Archive",
            };
        }

        if (actionTargetType === "list" && boardAction === "delete") {
            return {
                title: "Delete list?",
                text: <>This list will be permanently removed. This action cannot be undone.</>,
                buttonText: "Delete",
            };
        }

        return null;
    };

    const currentAction = getActionConfig();

    const archivedLists = lists.filter((el) => el.is_archive);
    const path = activeBoard?.path;

    const isUploadedImage = path?.startsWith("uploads");
    const bg = isUploadedImage
        ? `${IMAGE_URL}/media/${path}`
        : path || "#253545";

    return (
        <div
            className="boardPage"
            style={
                isUploadedImage
                    ? {
                        backgroundImage: `url(${bg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }
                    : {
                        background: bg,
                    }
            }
        >
            <BoardPageHeader
                isChangeBoardText={isChangeBoardText}
                setIsChangeBoardText={setIsChangeBoardText}
                handleChangeBoardName={handleChangeBoardName}
                menuRef={menuRef}
                setIsMenuOpen={setIsMenuOpen}
                isMenuOpen={isMenuOpen}
                handleOpenActionModal={handleOpenActionModal}
                handleArchiveItems={handleArchiveLists}
                handleArchiveCards={handleArchiveCards}
            />

            <div className="boardPage__content">
                <Lists setOpenListMenuId={setOpenListMenuId} openListMenuId={openListMenuId}
                       handleOpenActionModal={handleOpenActionModal} activeListId={activeListId}
                       setActiveListId={setActiveListId} handleCreateCard={handleCreateCard} setCardTitle={setCardTitle}
                       cardTitle={cardTitle}/>

                {!showCreateList ? (
                    <button
                        type="button"
                        className="boardPage__addList"
                        onClick={() => setShowCreateList(true)}
                    >
                        + Add another list
                    </button>
                ) : (
                    <ListCreate handleCreateList={handleCreateList} listTitle={listTitle} setListTitle={setListTitle}
                                setShowCreateList={setShowCreateList}/>
                )}
            </div>

            <ModalArchiveLists isCloseModalOpen={isCloseModalOpen} actionTargetType={actionTargetType}
                               modalRef={modalRef} closeModal={closeModal} handleRestoreList={handleRestoreList}
                               currentAction={currentAction} handleConfirmAction={handleConfirmAction}/>
            <ModalArchiveBoard isCloseModalOpen={isCloseModalOpen} currentAction={currentAction}
                               actionTargetType={actionTargetType} modalRef={modalRef} closeModal={closeModal}
                               handleConfirmAction={handleConfirmAction}/>

            {actionTargetType === "archiveLists" && (
                <div className="closeBoardModalOverlay">
                    <div className="closeBoardModal archiveItemsModal" ref={modalRef}>
                        <div className="closeBoardModal__header">
                            <h3>Archived lists</h3>
                            <button
                                type="button"
                                className="closeBoardModal__close"
                                onClick={closeModal}
                            >
                                ✕
                            </button>
                        </div>

                        <ArchiveLists handleRestoreList={handleRestoreList}/>
                    </div>
                </div>
            )}
            {actionTargetType === "archiveCards" && (
                <div className="closeBoardModalOverlay">
                    <div className="closeBoardModal archiveItemsModal" ref={modalRef}>
                        <div className="closeBoardModal__header">
                            <h3>Archived Cards</h3>
                            <button
                                type="button"
                                className="closeBoardModal__close"
                                onClick={closeModal}
                            >
                                ✕
                            </button>
                        </div>

                        <ArchiveCards/>
                    </div>
                </div>
            )}
            {
                isShowShare && (
                    <ShareModal/>
                )
            }
        </div>
    );
};
